import s from './AuthDivider.module.css';

interface AuthDividerProps {
  label: string;
}

/** Labelled rule separating the SSO button from the email/password form. */
export function AuthDivider({ label }: AuthDividerProps): JSX.Element {
  return (
    <div className={s.root}>
      <span className={s.label}>{label}</span>
    </div>
  );
}
